import React,{useEffect, useState} from "react";
import { ContactUsData, fetchContactData} from "./helper";
import GenericTable from '../GenericTable/table';
import Swal from 'sweetalert2'
import SkeletonCard from '../Auth/Components/SkeletonCard'
import { Tooltip } from 'react-tooltip'
import { updateContactStatus } from "../../../api";


type SortConfig = {key: string; direction: 'asc' | 'desc' | null}

const ContactUs = () => {
  const [columns, setColumns] = useState<string[]>([])
  const [data, setData] = useState<Record<string, any>[]>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedDays, setSelectedDays] = useState({
    startDate: '',
    endDate: ''
  })
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageData, setCurrentPageData] = useState<Record<string, any>[]>([]);
  const [totalPages, setTotalPages] = useState<number>(1);
  const itemsPerPage = 10;
  const [sortConfig, setSortConfig] = useState<SortConfig>({key: '', direction: null})

 
  //  useEffect(() =>{

  //   setColumns(ContactUsData.columns);
  //   setData(ContactUsData.data);
  //   setLoading(false); 

  //  },[])
  const fetchData = async () => {
    setLoading(true);
    const response = await fetchContactData(currentPage, itemsPerPage);
  
    if (response) {
      setColumns(Object.keys(response.contacts[0] || {}));
      setData(response.contacts);
      setTotalPages(response.totalPages);
    }
  
    setLoading(false);
  };
  
  useEffect(() => {
    fetchData();
  }, [currentPage]);
  

   const sortData = (data: Record<string, any>[], column: string) => {
    const sortableData = [...data]
    sortableData.sort((a, b) => {
      const aValue = a[column]
      const bValue = b[column]

      const aDate = Date.parse(aValue)
      const bDate = Date.parse(bValue)
      if (!isNaN(aDate) && !isNaN(bDate)) {
        return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate
      }

      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortConfig.direction === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      return 0
    })

    return sortableData
  }

  const handleSort = (column: string) => {
    setSortConfig((prevConfig) => {
      const direction = prevConfig.key === column && prevConfig.direction === 'asc' ? 'desc' : 'asc'
      return {key: column, direction}
    })

    const sortedData = sortData(data, column)
    setData(sortedData)
    //setCurrentPage(1); // Reset to first page after sorting
  }

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }
 
  

  const handleStatusChange = (rowId: number, newStatus: string) => {
    const selectedRow = data.find((row) => row.Id === rowId);
  
    if (!selectedRow) {
      Swal.fire('Error', 'Selected row not found.', 'error');
      return;
    }

    console.log(selectedRow,"selected row");
    console.log(rowId,"row ID")
  
    Swal.fire({
      title: `Are you sure you want to change the status to ${newStatus}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call the API to update status in backend
          await updateContactStatus({ contact_id: rowId, status: newStatus });
  
         
          setData((prevData) =>
            prevData.map((row) =>
              row.Id === rowId ? { ...row, Status: newStatus } : row
            )
          );
  
          await fetchData();
        
  
          Swal.fire('Updated!', `Status has been changed to ${newStatus}.`, 'success');
        } catch (error) {
          Swal.fire('Error', 'Failed to update status.', 'error');
        }
      }
    });
  };
  
  

  useEffect(() => {
    const filteredData = data.filter((row) => {
      const matchesSearch = Object.values(row)
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase())

      return matchesSearch
    })
    setTotalPages(Math.ceil(filteredData.length / itemsPerPage))

    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    const currentPageData = filteredData.slice(startIndex, endIndex)

    setCurrentPageData(currentPageData)
  }, [data, currentPage, searchTerm])

  return (
    <div>
      {loading ? (
        <SkeletonCard />
      ) : (
        <>
          <GenericTable
            columns={columns}
            handleNextClick={handleNextClick}
            handlePriviousClick={handlePreviousClick}
            data={currentPageData}
            searchTerm={searchTerm}
            handleSort={handleSort}
            sortConfig={sortConfig}
            onSearch={(term) => {
              setSearchTerm(term)
              setCurrentPage(1) // Reset page to 1 on search
            }}
            renderCell={(column, row, rowIndex) => {
              if (column === 'Status') {
                return (
                  <select
                    value={row.Status}
                    className='form-select form-select-solid w-150px'
                    onChange={(e) => handleStatusChange( row.Id,e.target.value)}
                  >
                    <option value='Pending'>Pending</option>
                    <option value='Contacted'>Contacted</option>
                  </select>
                )
              }
              if (column === "Comment") {
                const text = row[column] || "";
                const maxLength = 20;
                const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
              
                return (
                  <>
                    <span data-tooltip-id="comment-tooltip" data-tooltip-content={text}>
                      {truncatedText}
                    </span>
                    <Tooltip id="comment-tooltip" 
                        place="bottom" // Tooltip position: top, bottom, left, right
                        style={{ backgroundColor: "#6D9300", color: "#fff", padding: "4px", borderRadius: "6px" }}/>
                  </>
                );
              }
              return row[column]
            }}
          />

          <ul className='pagination justify-content-center' style={{margin: '15px 0'}}>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => {
                  if (handlePreviousClick) handlePreviousClick()
                }}
                disabled={currentPage === 1}
                aria-label='Previous'
              >
                &laquo; Previous
              </button>
            </li>

            <li className='page-item active'>
              <div className='d-flex align-items-center'>
                <button
                  className='page-link'
                  style={{backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none'}}
                >
                  {currentPage}
                </button>
                <span className='mx-2'>of</span>
                <button
                  className='page-link'
                  style={{backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none'}}
                >
                  {totalPages}
                </button>
              </div>
            </li>

            <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => {
                  if (handleNextClick) handleNextClick()
                }}
                disabled={currentPage >= totalPages}
                aria-label='Next'
              >
                Next &raquo;
              </button>
            </li>
          </ul>
        </>
      )}
    </div>
      )
}

export default ContactUs


